import * as React from "react";
import { RewardPointJournal } from "../types";
import { Props } from "../../types/global";
import { MyAccountService } from "./myaccount-service";
import { formatDate } from "../utils";
import { messageDialog } from "../dialogs/MessageDialog";
import t from "../i18n";
import { CatalogService } from "../services/catalog-service";

declare type RewardState = {
    rewardJournal : RewardPointJournal[]
}
export default class  RewardPoints extends React.Component<Props> {
    readonly state: RewardState = { rewardJournal: [] };
    async componentDidMount() {
        const response = await MyAccountService.fetchRewardPoints();
        if (!response) {
            this.setState({
                rewardJournal: [],
            });
        }
        if (response.responseCode === 0 && response.payLoad) {
            let total = 0;
            const points = response.payLoad
            points.forEach(rp => {
                total = total + rp.pointsEarned - rp.pointsUsed;
                rp.runningBalance = total;
            })
            this.setState({
                rewardJournal: points,                
            });
        }
    }
    async showRewardPointsOverview(){
        var text = await CatalogService.getRewardPolicyText();
        messageDialog(<p style={{textAlign: 'justify'}}>{text}</p>, `${t.myaccount("reward_points_policy")}`);
    }
    render() {
        const points = this.state.rewardJournal;
        return (
            <div className="container small-gutter" style={pageWidth}>
                <div className="form-group form-title">
                    <h2 style={{display:'inline-block'}}>{t.menu("reward_points")}</h2>                   
                    <a href="javascript:void(0)" onClick={this.showRewardPointsOverview} style={{float:'right', paddingTop: 15}}>
                        {t.myaccount("reward_points_policy")}
                    </a>                    
                </div>              
                <div>
                    <table style={{ width: "100%"}} className="table">
                        <tbody>
                            <tr>
                                <th style={{width : 100}}>Ref #</th>
                                <th style={{width : 100}}>{t.myaccount("date")}</th>
                                {/* <th style={{width : 100}}>Currency</th> */}
                                <th style={{width : 100}}>{t.myaccount("points_earned")}</th>
                                <th style={{width : 100}}>{t.myaccount("points_used")}</th>
                                <th style={{width : 100}}>{t.myaccount("balance")}</th>
                            </tr>
                            {points.length >= 0 && points.map( p=> (
                                    <tr>
                                    <td>{p.referenceId}</td>
                                    <td>{formatDate(p.rewardDate)}</td>
                                    {/* <td>{p.currencyCode}</td> */}
                                    <td>{p.pointsEarned}</td>
                                    <td>{p.pointsUsed}</td>
                                    <td>{p.runningBalance}</td>
                                    </tr>
                            ) )}
                            {points.length === 0 && 
                            <tr>
                                <td colSpan={5} style={{textAlign: "center", paddingTop: 20 }}>No Records found</td>
                            </tr>                                
                            }                           
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}
const pageWidth: React.CSSProperties = {
    maxWidth: 768,
    width: "100%",
}